<template>
  <component
    :is="tag"
    class="nav"
    :class="{
      'nav-tabs': tabs,
      'nav-pills': !tabs && pills,
      'nav-fill': !vertical && fill,
      'nav-justified': !vertical && justified,
      'flex-column': vertical,
      'small': small,
      'card-header-tabs': cardHeader,
      [`justify-content-${align}`]: !vertical && align
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BNav',
  props: {
    tag: {
      type: String,
      default: 'ul'
    },
    fill: {
      type: Boolean,
      default: false
    },
    justified: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: null
    },
    tabs: {
      type: Boolean,
      default: false
    },
    pills: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    cardHeader: {
      // Set to true if placing in a card header
      type: Boolean,
      default: false
    }
  }
}
</script>
